import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M20.393 14.518a.559.559 0 0 1-.559-.559c0-4.638-3.934-6.714-7.833-6.714s-7.833 2.076-7.833 6.714a.559.559 0 1 1-1.12 0c0-4.612 3.681-7.833 8.952-7.833s8.952 3.222 8.952 7.833c0 .309-.25.559-.559.559z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 17.875c-2.159 0-3.917-1.757-3.917-3.917S9.84 10.041 12 10.041s3.917 1.757 3.917 3.917S14.16 17.875 12 17.875zm0-6.714c-1.543 0-2.798 1.255-2.798 2.798s1.255 2.798 2.798 2.798 2.798-1.255 2.798-2.798-1.255-2.798-2.798-2.798z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3.691 7.749a.573.573 0 0 1 .887-.478l-.002-.001 14.674 9.553a.574.574 0 0 1-.627.96l.002.001L3.951 8.231a.573.573 0 0 1-.26-.481z"
  })]
}), 'EyeWithLine');